module.exports = __webpack_public_path__ + "img/charter-1.a4131fb.webp";